export const Order = (json: IOrder): IOrderModel => {
	const fromJSON = (orderJson: IOrder) => {
		const {
			client,
			started_at,
			ended_at,
			created_at,
			days_to_end,
			last_delivery_at,
			address,
			friendly_id,
			client_profile,
			days_count,
			days_left_count,
			diet,
			diet_id,
			first_diet_day,
			last_diet_day,
			next_delivery_date,
			last_delivery_date,
			address_id,
			diet_nickname,
			current_config,
			...rest
		} = orderJson
		return {
			client: client ? clientFromJSON(client) : null,
			startedAt: started_at ? new Date(started_at) : null,
			endedAt: ended_at ? new Date(ended_at) : null,
			createdAt: created_at ? new Date(created_at) : null,
			daysToEnd: days_to_end,
			lastDeliveryAt: last_delivery_at ? new Date(last_delivery_at) : null,
			diet: diet ? Diet(diet) : null,
			dietID: diet_id,
			address: address ? ClientAddress(address) : null,
			friendlyID: friendly_id,
			clientProfile: client_profile ? ClientProfile(client_profile) : null,
			daysCount: days_count,
			daysLeftCount: days_left_count,
			firstDietDay: first_diet_day ? new Date(first_diet_day) : null,
			lastDietDay: last_diet_day ? new Date(last_diet_day) : null,
			nextDeliveryDate: next_delivery_date ? new Date(next_delivery_date) : null,
			lastDeliveryDate: last_delivery_date ? new Date(last_delivery_date) : null,
			addressID: address_id,
			dietNickname: diet_nickname,
			currentConfig: current_config ? CurrentDietConfig(current_config) : null,
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const orderDayMealToJSON = (obj: IOrderDaysMealFormModel): IOrderDaysMealForm => {
	const { mealType, sizeID, variantID, ...rest } = obj
	return {
		meal_type: mealType,
		size_id: sizeID,
		variant_id: variantID,
		...rest,
	}
}

export const orderDayFormToJSON = (obj: IOrderDayFormModel): IOrderDayForm => {
	const { mealSlots, ...rest } = obj
	return {
		meal_slots: mealSlots ? mealSlots.map(m => orderDayMealToJSON(m)) : [],
		...rest,
	}
}

export const orderToJSON = (obj: Partial<IOrderSendFormModel>): Partial<IOrderSendForm> => {
	const { addressID, dietID, clientID, dietOrderDays, couponCode, dietNickname, ...rest } = obj
	return {
		address_id: addressID,
		diet_id: dietID,
		client_id: clientID,
		meal_kind: 'meal',
		diet_order_days: dietOrderDays ? dietOrderDays.map(day => orderDayFormToJSON(day)) : [],
		coupon_code: couponCode,
		diet_nickname: dietNickname,
		...rest,
	}
}

export const OrderDayForm = (json: IOrderDayForm): IOrderDayFormModel => {
	const fromJSON = (orderDayForm: IOrderDayForm) => {
		const { meal_slots, ...rest } = orderDayForm
		return {
			mealSlots: meal_slots,
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const OrderDayMeal = (json: IOrderDaysMealForm): IOrderDaysMealFormModel => {
	const fromJSON = (orderDayMeal: IOrderDaysMealForm) => {
		const { meal_type, ...rest } = orderDayMeal
		return {
			mealType: meal_type,
			...rest,
		}
	}

	return { ...fromJSON(json) }
}
